import React, { useEffect } from "react";
import cn from "classnames";
import { CheckIcon } from "../../icons";
import { useFilterContext } from "../head-bar/filter-context";
import { observer } from "mobx-react-lite";

export const SortFilter = observer(({ setOpen }) => {
  const { filterParams, order_by, setOrderBy } = useFilterContext();
  const onClick = (item) => {
    setOrderBy(item.value);
    setOpen("");
  };
  useEffect(() => {
    if (typeof document === "undefined" || !document.body) return;

    let created = false;
    let overlayEl = document.querySelector("body > .head-filter__sort-overlay");

    if (!overlayEl) {
      overlayEl = document.createElement("div");
      overlayEl.className = "head-filter__sort-overlay";
      overlayEl.style.background = "transparent";
      overlayEl.style['backdropFilter'] = "none";
      document.body.appendChild(overlayEl);
      created = true;
    }

    return () => {
      if (created && overlayEl && overlayEl.parentNode) {
        overlayEl.parentNode.removeChild(overlayEl);
      }
    };
  }, []);
  return (
    <div className="head-filter__sort">
      {filterParams.order_by.map((item) => {
        return (
          <div
            className={cn("filter__sort-item", {
              "filter__sort-item--active": order_by === item.value,
            })}
            key={item.value}
            onClick={() => onClick(item)}
          >
            <div className="filter__sort-label">{item.name}</div>
            {order_by === item.value && <CheckIcon></CheckIcon>}
          </div>
        );
      })}
    </div>
  );
});
